import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import _ from "lodash";
import { ModalContext } from "App";
import mfaGoogleAuthenticator from "assets/img/mfa/MfaGoogleAuthenticator.png";
import emptyStateImage from "assets/img/icn-empty-state.svg";
import PinInput from "modules/common/components/PinInput";
import CmsContext from "../../../../../CmsContext";
import * as actions from "../../../actions";
import * as c from "../../../constants";

function AuthenticatorSetup({
  generate2fa,
  goBack,
  enableMobileAuthenticator,
  history,
  profile,
  mfaLogin,
  isLoading,
  savePreferredLogin,
  selectedMfa,
  temporaryToken,
  getProfileInfo,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_LOGOS = cmsContext.findByType("LOGOS");
  const [formData, setFormData] = useState({});
  const [showOTP, setShowOTP] = useState(false);

  const handleOnGenerateQr = (e) => {
    e.preventDefault();

    generate2fa(
      {
        email: profile.email,
        token: temporaryToken,
      },
      (data) => {
        setFormData(data.data);
      }
    );
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    goBack(0);
  };

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnVerify = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      email: profile.email,
      token: temporaryToken,
      mfa_type: "google_authenticator",
    };

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" }).then((captcha_token) => {
        enableMobileAuthenticator({ ...args, recaptcha: captcha_token }, () => {
          const token = localStorage.getItem("token");
          if (selectedMfa === 1) {
            const mfaArgs = {
              token,
              preferred_mfa: "google_authenticator",
            };

            savePreferredLogin(mfaArgs, () => {
              getProfileInfo();
            });
          }
          setModal({ isOpen: false });
          setShowOTP(true);
          // history.push('/');
        });
      });
    });
  };

  useEffect(() => {
    if (!profile.is_google_2fa_enabled) {
      generate2fa(
        {
          email: profile.email,
          token: temporaryToken,
        },
        (data) => {
          setFormData(data.data);
        }
      );
    }
  }, []);

  const handleOnchangePin = (otp) => {
    setFormData({
      ...formData,
      otp,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      secret: formData.otp,
      mfa_type: "google_authenticator",
      token: temporaryToken,
    };
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" }).then((captcha_token) => {
        mfaLogin({ ...args, recaptcha: captcha_token }, () => {
          const token = localStorage.getItem("token");
          if (selectedMfa === 1) {
            const mfaArgs = {
              token,
              preferred_mfa: "google_authenticator",
            };
            savePreferredLogin(mfaArgs, () => {
              getProfileInfo();
            });
          }

          setModal({ isOpen: false });
          history.push("/");
        });
      });
    });
  };

  useEffect(() => {
    if (_.get(profile, "is_google_2fa_enabled") === true) {
      setShowOTP(true);
    }
  }, []);

  return (
    <>
      {!showOTP && _.get(profile, "is_google_2fa_enabled") === false && (
        <>
          <div>
            <button onClick={handleGoBack} type="button" className="mfa-back-button cms-text-primary my-2">
              <i className="fas fa-chevron-left mfa-back-login" /> Back
            </button>
          </div>
          <div className="mfa-container">
            <img src={_.get(CMS_LOGOS, "MAIN_LOGO.cdnUrl")} alt="" className="icon-logo mb-3" />
            <div className="cms-text-primary cms-outline-primary mfa-header text-left font-weight-bold">
              Please follow the steps below to enable MFA via Authenticator App:
            </div>
            <div className="mt-3 mfa-detail">1. Download an authenticator app</div>
            <div className="ml-3 mfa-setup-description">
              Install Google Authenticator on your phone. You&apos;ll use this app to generate verification codes when logging in. This app can be
              installed on your iOS/Android devices.
            </div>
            <div className="ml-3 mt-2">
              <button type="button" onClick={handleOnGenerateQr} className="btn-outline-primary btn-sm px-3 cms-text-primary cms-outline-primary">
                <img src={mfaGoogleAuthenticator} style={{ height: "20px", width: "20px" }} alt="MFA Google Authenticator" />
                <span className="mfa-detail ml-2">Google Authenticator</span>
              </button>
            </div>
            <div className="mt-3 mfa-detail">2. Scan QR Code with authenticator app</div>
            <div className="ml-3 mfa-setup-description">
              Open your downloaded authenticator app on your phone and scan the QR code. This will link the app to your account.
            </div>
            <div className="ml-3 mt-3 d-flex">
              {_.get(formData, "qr_code_url") ? (
                <>
                  <div className="col-6 border rounded-sm text-center">
                    <img
                      alt=""
                      src={_.get(formData, "qr_code_url")}
                      className="text-center mt-2 mb-2"
                    />
                  </div>
                  <div className="col-6 border rounded-sm ml-1 align-content-center p-1">
                    <div className="text-center mfa-setup-description mt-2">You can also enter this setup key:</div>
                    <div className="text-center mt-1 mb-2 cms-text-primary mfa-setup-description font-weight-bold text-break">
                      {`${_.get(formData, "google2fa_secret")}`}
                    </div>
                  </div>
                </>
              ) : (
                <div className="border text-center p-4">
                  <img
                    src={emptyStateImage}
                    className="img-responsive image-wrapper mb-4 mt-3"
                    alt="Empty State"
                    style={{ height: "150px", width: "150px", top: "-5px" }}
                  />
                </div>
              )}
            </div>
            <div className="mt-3 mfa-detail">3. Enter verification code</div>
            <div className="ml-3 mfa-setup-description">
              After scanning the QR code or entering the setup key above, your authenticator app will generate a verification code. Enter this code
              below to verify your setup.
            </div>
            <div className="input-group mt-2 px-3">
              <InputMask
                placeholder="Enter confirmation code"
                className="form-control"
                maskChar=" "
                mask="999999"
                autoComplete="none"
                id="secret"
                name="secret"
                onChange={handleOnChange}
                value={_.get(formData, "secret") || ""}
              />
              <div className="input-group-append">
                <button
                  type="button"
                  disabled={_.isEmpty(_.get(formData, "secret"))}
                  className="btn btn-primary btn-submit cms-bg-color-primary"
                  onClick={handleOnVerify}
                >
                  Submit
                </button>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button type="button" onClick={handleGoBack} className="btn btn-change cms-text-primary">
                <span className="font-weight-bold">Change Authentication Method</span>
              </button>
            </div>
          </div>
        </>
      )}
      {showOTP && (_.get(profile, "is_google_2fa_enabled") === true || _.get(profile, "preferred_mfa") === "google_authenticator") && (
        <>
          <div>
            <button onClick={handleGoBack} type="button" className="mfa-back-button cms-text-primary my-2">
              <i className="fas fa-chevron-left mfa-back-login" /> Back
            </button>
          </div>
          <form className="mfa-modal" onSubmit={handleOnSubmit}>
            <img src={_.get(CMS_LOGOS, "MAIN_LOGO.cdnUrl")} alt="" className="icon-logo mb-3" />
            <div className="form-header p-3 cms-bg-color-primary-ligt mfa-description">
              Multi-Factor Authentication is enabled. Please input the code shown in your authenticator app.
            </div>
            <div className="">
              <PinInput onChange={handleOnchangePin} />
            </div>
            <div className="mt-4">
              <button
                type="submit"
                className="btn btn-primary btn-block cms-bg-color-primary cms-outline-primary"
                disabled={isLoading || _.isEmpty(formData.otp)}
              >
                {isLoading && <i className="fa fa-spin fa-spinner" />}
                Submit
              </button>
            </div>
            <div className="text-center mt-2">
              <button type="button" onClick={handleGoBack} className="btn btn-change cms-text-primary">
                <span className="font-weight-bold">Change Authentication Method</span>
              </button>
            </div>
          </form>
        </>
      )}
    </>
  );
}

AuthenticatorSetup.propTypes = {
  generate2fa: PropTypes.instanceOf(Function).isRequired,
  goBack: PropTypes.instanceOf(Function).isRequired,
  enableMobileAuthenticator: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  profile: PropTypes.instanceOf(Object).isRequired,
  mfaLogin: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  savePreferredLogin: PropTypes.instanceOf(Function).isRequired,
  selectedMfa: PropTypes.number.isRequired,
  temporaryToken: PropTypes.string.isRequired,
  getProfileInfo: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  temporaryToken: sessionStorage.getItem("temporaryToken") || "",
  isLoading: _.get(api, "loading", []).indexOf(c.MFA_LOGIN) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
    getProfileInfo: actions.getProfile,
  }),
]);

export default enhance(AuthenticatorSetup);
